import { useQuery } from '@tanstack/react-query';
import fetchApi from './fetchApi';

const useUsersQuery = () =>
  useQuery({ queryKey: ['users'], queryFn: () => fetchApi<Odoo.User[]>('/api/users'), refetchOnWindowFocus: false });

export default useUsersQuery;
